/*
 * Rowdy: £10 sign-up tab and window (sections/rowdy-penpal.liquid).
 * Remembers in this browser whether someone has signed up (tab gone) or closed the tab (hidden for a few days).
 */
(function () {
  var KEY = 'rowdyPenpal', PENDING = 'rowdyPenpalPending';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var root = document.querySelector('[data-rpp]');
    if (!root) return;
    var dialog = root.querySelector('[data-rpp-dialog]');
    var tab = root.querySelector('[data-rpp-tab-wrap]');
    var form = root.querySelector('[data-rpp-form]');
    var app = root.querySelector('.rpp-app');
    var card = root.querySelector('[data-rpp-card]');
    var touch = window.matchMedia('(hover: none), (max-width: 749px)').matches;
    var msg = root.querySelector('[data-rpp-msg]');
    var submit = root.querySelector('[data-rpp-submit]');
    var submitText = root.querySelector('[data-rpp-submit-text]');
    var code = root.getAttribute('data-code') || '';
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 0;
    var snoozeDays = parseInt(root.getAttribute('data-snooze'), 10) || 7;
    var designMode = window.Shopify && window.Shopify.designMode;
    // Testing: add ?penpal=reset to any page address to see the offer again in this browser
    if (/[?&]penpal=reset\b/.test(location.search)) { try { localStorage.removeItem(KEY); } catch (e) {} }
    var state = read();
    var lastFocus = null;

    function step(name) {
      root.querySelectorAll('[data-rpp-step]').forEach(function (s) { s.hidden = s.getAttribute('data-rpp-step') !== name; });
    }
    function open(focusDone) {
      lastFocus = document.activeElement;
      if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute('open', '');
      document.documentElement.classList.add('rpp-locked');
      setTimeout(function () {
        // On phones, don't throw the keyboard up the moment the window opens
        var el = focusDone ? root.querySelector('[data-rpp-done-title]') : (touch ? root.querySelector('.rpp-title') : root.querySelector('input[type="email"]'));
        if (el) { if (touch && !focusDone) el.setAttribute('tabindex', '-1'); el.focus({ preventScroll: true }); }
      }, 60);
    }
    function close() {
      if (dialog.open && typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    }
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('rpp-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });
    function showTab() {
      tab.hidden = false;
      void tab.offsetWidth;
      setTimeout(function () { tab.classList.add('is-in'); }, 30);
    }
    function hideTab() { tab.classList.remove('is-in'); setTimeout(function () { tab.hidden = true; }, 400); }
    function done() {
      write({ state: 'joined', at: Date.now() });
      step('done');
      hideTab();
      var t = root.querySelector('[data-rpp-done-title]');
      if (t) t.focus();
    }

    // Returning from a normal (non-background) submit
    var pending = false;
    try { pending = sessionStorage.getItem(PENDING) === '1'; sessionStorage.removeItem(PENDING); } catch (e) {}
    var justJoined = pending && /customer_posted=true/.test(location.search + location.hash);
    if (justJoined) {
      write({ state: 'joined', at: Date.now() });
      state = read();
      step('done');
      setTimeout(function () { open(true); }, 50); // after the buttons below are wired up
    }

    // Show the tab unless they've joined or recently closed it
    var snoozed = state.state === 'snoozed' && state.until > Date.now();
    if (designMode) showTab();
    else if (state.state !== 'joined' && !snoozed) {
      if (!touch) setTimeout(showTab, delay * 1000);
      else {
        // Phones: wait until they've scrolled a little (or twice the delay), so the tab doesn't greet them on arrival
        var shown = false;
        var go = function () { if (shown) return; shown = true; window.removeEventListener('scroll', onScroll); showTab(); };
        var onScroll = function () { if (window.scrollY > window.innerHeight * 0.6) go(); };
        window.addEventListener('scroll', onScroll, { passive: true });
        setTimeout(go, delay * 2000);
      }
    }

    root.querySelector('[data-rpp-open]').addEventListener('click', function () { step('form'); open(false); });
    root.querySelector('[data-rpp-dismiss]').addEventListener('click', function () {
      write({ state: 'snoozed', until: Date.now() + snoozeDays * 864e5 });
      hideTab();
    });
    root.querySelector('[data-rpp-close]').addEventListener('click', close);
    // Click on the dimmed backdrop closes
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

    // Swipe the sheet down to close (phones)
    (function () {
      var startY = null, dy = 0;
      card.addEventListener('touchstart', function (e) {
        var body = root.querySelector('.rpp-body');
        if (body && body.scrollTop > 0) return;
        startY = e.touches[0].clientY; dy = 0; card.style.transition = 'none';
      }, { passive: true });
      card.addEventListener('touchmove', function (e) {
        if (startY === null) return;
        dy = Math.max(0, e.touches[0].clientY - startY);
        if (dy > 0) card.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      card.addEventListener('touchend', function () {
        if (startY === null) return;
        card.style.transition = ''; card.style.transform = '';
        if (dy > 90) close();
        startY = null;
      });
    })();

    // A Shopify Form inside the window: once it's sent, treat them as signed up (it shows its own code)
    if (app) app.addEventListener('submit', function () { setTimeout(function () { write({ state: 'joined', at: Date.now() }); hideTab(); }, 1500); }, true);

    if (!form) return;

    // Came back from a send that Shopify didn't accept (e.g. a mistyped email): reopen with its message
    var msgText = msg && msg.textContent.trim();
    if (pending && msg && msg.hasAttribute('data-rpp-has-error') && msgText) { step('form'); open(false); }

    // Sign up: Shopify's own form post, so its spam check can run (usually invisible). The window reopens on the code on return.
    form.addEventListener('submit', function (e) {
      var email = form.querySelector('input[type="email"]');
      msg.textContent = '';
      if (!email.value || !email.checkValidity()) {
        e.preventDefault();
        msg.textContent = 'Please enter a valid email address.';
        email.focus();
        return;
      }
      try { sessionStorage.setItem(PENDING, '1'); } catch (er) {}
      var was = submitText.textContent;
      submit.disabled = true;
      submitText.textContent = 'Just a moment…';
      // Re-enable if the page doesn't move on (e.g. the spam check was closed)
      setTimeout(function () { submit.disabled = false; submitText.textContent = was; }, 15000);
    });

    // Copy the code
    var copyBtn = root.querySelector('[data-rpp-copy]');
    copyBtn.addEventListener('click', function () {
      var label = root.querySelector('[data-rpp-copy-text]');
      var ok = function () { label.textContent = 'Copied'; copyBtn.classList.add('is-done'); setTimeout(function () { label.textContent = 'Copy'; copyBtn.classList.remove('is-done'); }, 2200); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, function () {});
      else {
        var r = document.createRange(); r.selectNodeContents(root.querySelector('[data-rpp-code]'));
        var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
        try { document.execCommand('copy'); ok(); } catch (er) {}
      }
    });

    // Add the code to the bag (cart if it has items, otherwise saved for checkout)
    var applyBtn = root.querySelector('[data-rpp-apply]');
    applyBtn.addEventListener('click', function () {
      var label = root.querySelector('[data-rpp-apply-text]');
      applyBtn.disabled = true;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.item_count) return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' });
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
        codes.push(code);
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        });
      }).then(function () {
        label.textContent = 'Added to your bag ✓';
        applyBtn.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('rowdy:discount-applied', { detail: { code: code } }));
      }).catch(function () {
        applyBtn.disabled = false;
        label.textContent = 'Use the code at checkout';
      });
    });
  });
})();
